import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setSessionToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        // Referral code — captured from the landing URL (e.g. `/?ref=CODE`)
        // and stashed in localStorage until the OAuth callback fires.
        const referral_code = localStorage.getItem("ref_code") || undefined;
        const { data } = await api.post("/auth/session", {
          session_id: sessionId, referral_code,
        });
        if (referral_code) localStorage.removeItem("ref_code");
        // Capacitor / mobile fallback: cross-origin cookies can be blocked
        // by iOS ITP. The backend echoes `session_token` in the body so we
        // can attach it as `Authorization: Bearer` on subsequent requests.
        if (data?.session_token) setSessionToken(data.session_token);
        setUser(data.user);
        // Strip hash, send into app
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-page">
      <div className="brutal-card p-8 text-center">
        <p className="overline mb-2">Signing you in</p>
        <h2 className="font-display text-2xl font-black">One sec…</h2>
      </div>
    </div>
  );
}
